import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-263590b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container flex-column" }
const _hoisted_2 = {
  class: "sw-app-header--row-one",
  style: {"width":"100%"}
}
const _hoisted_3 = { class: "sw-app-header--brand-container d-flex flex-column flex-lg-row align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sw-app-header--catch-copy order-1 order-lg-2" }, " 得意な工程で参加できるWEBTOONとマンガの投稿サイト ", -1))
const _hoisted_5 = { class: "d-none d-lg-block sw-app-header--actions" }
const _hoisted_6 = { class: "d-flex flex-row" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 投稿ガイドライン")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 初めての方へ")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" ログイン")
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" お知らせ")
const _hoisted_14 = { key: 3 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" マイページ")
const _hoisted_16 = { key: 4 }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" ログアウト")
const _hoisted_18 = {
  class: "sw-app-header--row-two collapse navbar-collapse",
  id: "swAppHeaderCollapse",
  style: {"width":"100%"}
}
const _hoisted_19 = { class: "container sw-app-header--search" }
const _hoisted_20 = { class: "sw-app-header--menu" }
const _hoisted_21 = { class: "d-block d-lg-none sw-app-header--actions" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 投稿ガイドライン")
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 初めての方へ")
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" ログイン")
const _hoisted_27 = { key: 2 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" お知らせ")
const _hoisted_29 = { key: 3 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" マイページ")
const _hoisted_31 = { key: 4 }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" ログアウト")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container sw-app-header--toggler d-lg-none justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "sw-app-header--toggler-button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#swAppHeaderCollapse",
    "aria-controls": "swAppHeaderCollapse",
    "aria-expanded": "false",
    "aria-label": "Toggle navigation"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "sw-icon-menu" })
  ])
], -1))

import {
  ref,
  computed,
  withDefaults,
  inject,
  onMounted,
  watch,
} from 'vue';
import { SAVE_SEARCH_KEYWORD_MUTATION, useStore } from '@/store';
import { useRouter } from 'vue-router';
import SwBrand from '../molecules/SwBrand.vue';
import SwIcon from '../molecules/Icons/SwIcon.vue';
import SwTextField from '../molecules/Forms/SwTextField.vue';
import SwNavbarButtons, { NavbarMenuItemType } from '../molecules/Buttons/SwNavbarButtons.vue';
import useUsersFunc from '../utils/UsersUtil';

interface Emits {
  (e: 'change:searchKeyword', data?: string): void;
}
interface Props {
  color?: 'primary';
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SwAppHeader',
  props: {
    color: { default: 'primary' }
  },
  emits: ["change:searchKeyword"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change:searchKeyword', data?: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { color: 'primary' }

const userUtil = useUsersFunc();





const navbarItems = ref<NavbarMenuItemType[]>([
  {
    label: 'お気に入り',
    icon: 'sw-icon-like',
    to: '/mypage/favorites',
  },
  // {
  //   label: '掲示板',
  //   icon: 'sw-icon-announce',
  //   to: '/',
  // },
  {
    label: '投稿作品',
    icon: 'sw-icon-work',
    to: '/mypage',
  },
]);

const store = useStore();
const router = useRouter();

const me = computed(() => store.state.me);
const searchKeyword = ref<string>();
const isLoggedIn = ref<boolean>(false);
isLoggedIn.value = userUtil.isLoggedIn();
/**
 * 検索文字列
 */
const searchKeywordValue = computed({
  get: () => searchKeyword.value,
  set: (value) => {
    searchKeyword.value = value;
    emit('change:searchKeyword', searchKeyword.value);
  },
});
/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-app-header': true,
  [`sw-app-header--${props.color || 'primary'}`]: true,
}));

/**
 * 検索文字列変更
 */
const onChangeSearchKeyword = () => {
  store.commit(SAVE_SEARCH_KEYWORD_MUTATION, { searchKeyword: searchKeyword.value });
};

const onKeydown = (e: KeyboardEvent) => {
  if (e.keyCode === 13) {
    e.preventDefault();
    store.commit(SAVE_SEARCH_KEYWORD_MUTATION, { searchKeyword: searchKeyword.value });
    // 遷移
    router.push('/works');
  }
};
const onClickSearchIcon = () => {
  store.commit(SAVE_SEARCH_KEYWORD_MUTATION, { searchKeyword: searchKeyword.value });
  // 遷移
  router.push('/works');
};

/**
 * サインアウト
 */
const doSignout = () => {
  userUtil.doSignout();
};

/**
 * me の変更を検知して表示データをリフレッシュ
 */
watch(me, async () => {
  // ログイン状態を取り直し
  isLoggedIn.value = userUtil.isLoggedIn();
});

onMounted(() => {
  searchKeywordValue.value = store.state.searchKeyword;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass([_unref(classes), "navbar navbar-light navbar-expand-lg sp-sticky-top flex-column"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "sw-app-header--brand navbar-brand order-2 order-lg-1"
          }, {
            default: _withCtx(() => [
              _createVNode(SwBrand, {
                "site-name": "SPOTWRITE",
                "site-sub-name": "スポットライト",
                "catch-copy": "得意な工程で参加できるWEBTOONとマンガの投稿サイト",
                horizontal: true
              })
            ]),
            _: 1
          }),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/guidelines" }, {
                default: _withCtx(() => [
                  _createVNode(SwIcon, {
                    icon: "sw-icon-guide",
                    size: "small",
                    shape: "solid",
                    color: "primary"
                  }),
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            (!isLoggedIn.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createVNode(_component_router_link, { to: "/first" }, {
                    default: _withCtx(() => [
                      _createVNode(SwIcon, {
                        icon: "sw-icon-first",
                        size: "small",
                        shape: "solid",
                        color: "primary"
                      }),
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (!isLoggedIn.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                  _createVNode(_component_router_link, { to: "/signin" }, {
                    default: _withCtx(() => [
                      _createVNode(SwIcon, {
                        icon: "sw-icon-login",
                        size: "small",
                        shape: "solid",
                        color: "primary"
                      }),
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (isLoggedIn.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                  _createVNode(_component_router_link, { to: "/informations" }, {
                    default: _withCtx(() => [
                      _createVNode(SwIcon, {
                        icon: "sw-icon-info",
                        size: "small",
                        shape: "solid",
                        color: "primary"
                      }),
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (isLoggedIn.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                  _createVNode(_component_router_link, { to: "/mypage" }, {
                    default: _withCtx(() => [
                      _createVNode(SwIcon, {
                        icon: "sw-icon-smile",
                        size: "small",
                        shape: "solid",
                        color: "primary"
                      }),
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (isLoggedIn.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                  _createElementVNode("a", {
                    onClick: doSignout,
                    href: "javascript:void(0);"
                  }, [
                    _createVNode(SwIcon, {
                      icon: "sw-icon-logout",
                      size: "small",
                      shape: "solid",
                      color: "primary"
                    }),
                    _hoisted_17
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(SwTextField, {
              modelValue: _unref(searchKeywordValue),
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchKeywordValue) ? (searchKeywordValue).value = $event : null)),
                onChangeSearchKeyword
              ],
              onKeydown: onKeydown,
              onClickAppendIcon: onClickSearchIcon,
              "append-icon": "sw-icon-search",
              placeholder: "キーワードで検索"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(SwNavbarButtons, { items: navbarItems.value }, null, 8, ["items"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/guidelines" }, {
                  default: _withCtx(() => [
                    _createVNode(SwIcon, {
                      icon: "sw-icon-guide",
                      size: "small",
                      shape: "solid",
                      color: "primary"
                    }),
                    _hoisted_22
                  ]),
                  _: 1
                })
              ]),
              (!isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                    _createVNode(_component_router_link, { to: "/first" }, {
                      default: _withCtx(() => [
                        _createVNode(SwIcon, {
                          icon: "sw-icon-first",
                          size: "small",
                          shape: "solid",
                          color: "primary"
                        }),
                        _hoisted_24
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (!isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                    _createVNode(_component_router_link, { to: "/signin" }, {
                      default: _withCtx(() => [
                        _createVNode(SwIcon, {
                          icon: "sw-icon-login",
                          size: "small",
                          shape: "solid",
                          color: "primary"
                        }),
                        _hoisted_26
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                    _createVNode(_component_router_link, { to: "/informations" }, {
                      default: _withCtx(() => [
                        _createVNode(SwIcon, {
                          icon: "sw-icon-info",
                          size: "small",
                          shape: "solid",
                          color: "primary"
                        }),
                        _hoisted_28
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                    _createVNode(_component_router_link, { to: "/mypage" }, {
                      default: _withCtx(() => [
                        _createVNode(SwIcon, {
                          icon: "sw-icon-smile",
                          size: "small",
                          shape: "solid",
                          color: "primary"
                        }),
                        _hoisted_30
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                    _createElementVNode("a", {
                      onClick: doSignout,
                      href: "javascript:void(0);"
                    }, [
                      _createVNode(SwIcon, {
                        icon: "sw-icon-logout",
                        size: "small",
                        shape: "solid",
                        color: "primary"
                      }),
                      _hoisted_32
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_33
  ], 2))
}
}

})